import {useQuery} from 'react-query'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {JudolEditModalForm} from './JudolEditModalForm'
import {getJudolById} from '../core/_requests'
import {useState} from 'react'
import {initialJudi, Judi} from '../../../judi/judi-list/core/_models'
import {initialJudol, Judol} from '../core/_models'

const JudolEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const [dataToUpdate, setDataToUpdate] = useState<Judol>(initialJudol)
  const {isLoading, data, error} = useQuery(
    `${QUERIES.PUBLIC_USERS_LIST}-judol-${itemIdForUpdate}`,
    () => {
      const result = getJudolById(itemIdForUpdate)
      result.then((item) => {
        setDataToUpdate(item || initialJudol)
      })
      return result
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      refetchOnWindowFocus: false,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return (
      <JudolEditModalForm
        isLoading={isLoading}
        judol={dataToUpdate}
      />
    )
  }

  if (!error) {
    // @ts-ignore
    return <JudolEditModalForm isLoading={isLoading} judol={dataToUpdate} />
  }

  return null
}

export {JudolEditModalFormWrapper}
